var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('Header',{attrs:{"active":2}}),_c('img',{attrs:{"src":"https://szj-asset.oss-cn-shenzhen.aliyuncs.com/official/tu.png","alt":"上职家、蓝领、区块链、人力资源、企业直招"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }